import { render } from "./ListeProfilPage.vue?vue&type=template&id=afd9509c&ts=true"
import script from "./ListeProfilPage.vue?vue&type=script&lang=ts"
export * from "./ListeProfilPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__